import React from 'react'
import { Link as LinkBase } from 'react-router-dom'
import { Container as ContainerBase, Grid as GridBase, styled } from '@mui/material'
import { Tabs as TabsBase } from '@chilecompra/react-kit/components'

export const Root = styled(ContainerBase)`
  &.MuiContainer-root {
    padding: 22px 38px 48px;
  }
`

export const GridContainer = styled(props => <GridBase container {...props} />)`
  &.MuiGrid-container {
    height: ${props => props.height};
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ textAlign, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
    text-align: ${props => props.textAlign};
  }
`

export const Title = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 27px;
  font-weight: bold;
  line-height: 32px;
  margin: 0;
  padding: 0;
`

export const Description = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  line-height: 20px;
  margin: 0;
  padding: 0;
`

export const Link = styled(LinkBase)`
  color: ${props => props.theme.palette.brand.primary};
  font-size: 14px;
  text-decoration: none;
`

export const PopoverContent = styled('div')`
  background-color: ${props => props.theme.palette.brand.white};
  padding: 15px;
  width: 491px;
`

export const Tabs = styled(TabsBase)`
  &.MuiTabs-root {
    min-height: 30px;
  }

  &.MuiTabs-root + div {
    padding: 16px 0;
  }

  & .MuiTab-root {
    line-height: 20px;
    min-height: 30px;
    min-width: 120px;
    padding: 0 15px 5px;
  }
`
